import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { NAV, SERVICES, CONTACT } from "../data/site";

export const Footer = () => (
  <footer data-testid="footer" className="bg-js-charcoal text-white/70">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <Link to="/" className="inline-flex mb-5">
          <img src="/logo-white.png?v=3" alt="J&S Air Conditioning" className="h-10 w-auto" />
        </Link>
        <p className="text-sm leading-relaxed max-w-xs">Melbourne's trusted heating & cooling specialists since 1988. Premium residential and commercial HVAC.</p>
      </div>
      <div>
        <h4 className="text-white font-display font-semibold mb-4 text-sm tracking-wide">Explore</h4>
        <ul className="space-y-2.5 text-sm">
          {NAV.map((n) => (
            <li key={n.to}><Link to={n.to} className="hover:text-white transition-colors duration-300">{n.label}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="text-white font-display font-semibold mb-4 text-sm tracking-wide">Services</h4>
        <ul className="space-y-2.5 text-sm">
          {SERVICES.map((s) => (
            <li key={s.slug}><Link to={`/services/${s.slug}`} className="hover:text-white transition-colors duration-300">{s.name}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="text-white font-display font-semibold mb-4 text-sm tracking-wide">Get in touch</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex gap-3"><Phone size={16} className="text-js-blue mt-0.5" /><a href={CONTACT.phoneHref} className="hover:text-white">{CONTACT.phone}</a></li>
          <li className="flex gap-3"><Mail size={16} className="text-js-blue mt-0.5" /><a href={`mailto:${CONTACT.email}`} className="hover:text-white break-all">{CONTACT.email}</a></li>
          {CONTACT.addresses.map((a) => (
            <li key={a.value} className="flex gap-3"><MapPin size={16} className="text-js-blue mt-0.5 shrink-0" /><span>{a.value}</span></li>
          ))}
          <li className="flex gap-3"><Clock size={16} className="text-js-blue mt-0.5" />{CONTACT.hours}</li>
        </ul>
        <Link to="/quote" className="inline-block mt-5 px-5 py-2.5 rounded-full bg-js-red text-white text-sm font-semibold hover:bg-js-red/90 transition-colors duration-300">Request Free Quote</Link>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs">
        <span>© {new Date().getFullYear()} J&amp;S Air Conditioning. J & S AIRCONDITIONING PTY LTD · ABN 84 055 063 548. Licensed & Insured.</span>
        <span>Servicing Melbourne & regional Victoria.</span>
      </div>
    </div>
  </footer>
);
